export default __webpack_public_path__ + "images/0xff970a61a04b1ca14834a43f5de4533ebddb5cc8.png";